@if (hasErrors()) {
  @for (error of errors() | keyvalue; track $index) {
    <div class="text-danger mt-0">
      {{ error.value?.['message'] || getErrorMessage() }}
    </div>
  }
}
